import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BaseConfigService } from '@base-shared/services/base-config.service';
import { Location } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute, Route, ActivatedRouteSnapshot, Params } from '@angular/router';
import { filter, map, mergeMap, tap, distinctUntilChanged } from 'rxjs/operators';
import { forEach, get, isNull, chain, sortBy } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { HeaderService, SeoService, NavigationService, AuthService, UserService } from '@base/shared/services';
import { HeaderHelperOptions } from '@base-interfaces/header-helper';
import { RouterParams } from '@eyrus/shared/services';
import { EyrusWarningModalComponent } from '@base-shared/components/warning-modal/warning-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass'],
  // entryComponents: [
  //   EyrusWarningModalComponent
  // ]
})
export class HeaderComponent implements OnInit {

  @ViewChild('header') header: ElementRef;

  client: any;
  currentUser: any = {};
  currentUserAccounts: any = [];
  dropdownItems: any;
  title: String = '';
  iconOptions: HeaderHelperOptions = {};
  subview: Boolean = false;
  displaySubbanner = false;
  bannerShowClose = false;
  bannerType: String = '';
  userType: String = '';
  userAccount: any = {};
  accountId: any;
  currentCompany: any = {}
  opened: boolean = false;

  private currentRouteData: any = {};
  private subscriptions: any = {};
  private quick: Boolean = false;
  private quickSettings: any = {};
  private defaultTitle: String = '';

  constructor(
    private appClient: BaseConfigService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private accountservice: UserService,
    private translate: TranslateService,
    private headerService: HeaderService,
    private navigation: NavigationService,
    private seoService: SeoService,
    private routerParamsService: RouterParams,
    //public eyrusWarningModalComponent : EyrusWarningModalComponent,
    private modalService: NgbModal
  ) {
    this.listenRouteChange();
    this.client = this.appClient.client;
  }

  ngOnInit() {
    this.currentUser = get(this.authService, 'user') || {};
    this.currentUserAccounts = this.currentUser.accounts || [];
    this.currentUserAccounts = sortBy(this.currentUserAccounts, ['accountName'])
    this.accountId = get(this.authService, 'accountId');

    if (this.accountId)
      this.currentCompany = this.currentUser.accounts.find(e => e.accountId.toString() === this.accountId.toString()) || {};

    console.log('this.currentUser', this.currentUser);
    this.headerService.checkSubBanner();

    this.subscriptions.icon = this.headerService.iconSet
      .subscribe((options: HeaderHelperOptions) => {
        this.iconOptions = options;
      });

    this.subscriptions.titleSet = this.headerService.titleSet
      .subscribe(title => {
        this.title = title || this.defaultTitle;
      });

    this.subscriptions.tabTitle = this.headerService.tabTitleSet
      .subscribe(tabTitle => {
        this.seoService.generateTags({ title: tabTitle });
      });

    this.subscriptions.setDisplay = this.headerService.displayHeader
      .subscribe(display => {
        this.header.nativeElement.style.display = display ? 'flex' : 'none';
      });

    this.subscriptions.quickAccessBack = this.headerService.quickBack
      .subscribe(quick => {
        if (quick) {
          this.quick = true;
          this.quickSettings = quick;

          return;
        }

        this.quick = false;
        this.quickSettings = {};
      });

    this.subscriptions.displaySubbanner = this.headerService.displaySubHeader
      .subscribe(res => {
        this.displaySubbanner = res.display;
        this.bannerType = res.bannerType;
        this.userType = res.userType;
        this.bannerShowClose = res.close;
        this.userAccount = res.account || {};
      });

  }

  ngOnDestroy() {
    forEach(this.subscriptions, (value) => value.unsubscribe());
  }

  /**
   * Display side panel
   */
  openMenu() {
    this.headerService.openSidePanel();
  }

  /**
   * Go back to previous route
   */
  goBack() {

    if (!this.quick)
      return this.navigation.navigate(this.currentRouteData);

    this.quickSettings.action();
  }

  /**
   * Run function that live in iconOptions
   */
  runAction() {
    if (this.iconOptions.action instanceof Function)
      this.iconOptions.action();
  }

  bannerClosed(close) {
    this.displaySubbanner = false;
    this.headerService.showSubheader = false;
  }

  /**
* Open a modal instance
* to confirm task delete
*/
  confirmSwitchChange(account) {

    const modalRef = this.modalService.open(EyrusWarningModalComponent);

    modalRef.componentInstance.message = 'switchAccounts.modalWarning';

    modalRef.result
      .then((res) => this.switchAccount(account))
      .catch(err => { });
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1.toString() === o2.toString();
  }


  switchAccount(account) {
    this.authService.switchUserAccount(account);
    this.router.navigate(['/eyrus/projects']);
    window.location.href = '/eyrus/projects';
  }


  /**
   * Listen all route events and get title from router
   */
  private listenRouteChange() {
    this.subscriptions.title = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route: ActivatedRoute) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route: ActivatedRoute) => route.outlet === 'primary'),
        mergeMap(route => route.data),
      )
      .subscribe((event) => {

        this.currentRouteData = event;
        const data = event;
        const title = get(data, 'title') || '';
        const subview = get(data, 'subview') || false;

        if (title) {
          this.title = this.translate.instant(title);
          this.defaultTitle = this.title;

          if (data.inTitle)
            this.seoService.generateTags({ title: this.title });
        }

        if (data.setTitle)
          this.getCustomTitle(data.title);

        this.subview = subview;
        this.headerService.breadcrumbsListener.next(event);
      });
  }


  private getCustomTitle(title) {
    if (title.toLowerCase().indexOf('companyname') !== -1)
      this.title = get(this.accountservice.account, 'contract.company.companyName');
  }

  sameAccount(id) {
    return id.toString() === this.accountId.toString();
  }
}
